import { I18nSelector } from '../types';

interface Steps {
	imagePath: string;
	title: I18nSelector;
	paragraph: I18nSelector;
	homePageDescriptions?: I18nSelector;
	link?: [path: string, name: I18nSelector];
	alt: I18nSelector;
}

export const steps: Steps[] = [
	{
		imagePath: '/lulav-icons/purim-icon.svg',
		title: i18n => i18n.hiw.steps.kit.title,
		paragraph: i18n => i18n.hiw.steps.kit.paragraph,
		homePageDescriptions: i18n => i18n.homePageText.flowchart.chooseKit,
		alt: i18n => i18n.alts.steps.mishloachManot
	},
	{
		imagePath: '/lulav-icons/hand-shake.svg',
		title: i18n => i18n.hiw.steps.associations.title,
		paragraph: i18n => i18n.hiw.steps.associations.paragraph,
		homePageDescriptions: i18n => i18n.homePageText.flowchart.pickAssociation,
		alt: i18n => i18n.alts.steps.heartHandShake
	},
	{
		imagePath: '/lulav-icons/locations.svg',
		title: i18n => i18n.hiw.steps.distributionStations.title,
		paragraph: i18n => i18n.hiw.steps.distributionStations.paragraph,
		link: ['/distribution-stations', i18n => i18n.hiw.steps.distributionStations.linkTitle],
		alt: i18n => i18n.alts.steps.locationMarker
	},
	{
		imagePath: '/lulav-icons/israel-shekel.svg',
		title: i18n => i18n.hiw.steps.payment.title,
		paragraph: i18n => i18n.hiw.steps.payment.paragraph,
		homePageDescriptions: i18n => i18n.homePageText.flowchart.charityProceeds,
		alt: i18n => i18n.alts.steps.shekel
	}
]

interface WhyUs {
	imagePath: string;
	text: I18nSelector;
	alt: I18nSelector;
}

export const whyUs: WhyUs[] = [
	{
		imagePath: '/lulav-icons/stars.svg',
		text: i18n => i18n.hiw.whyUs.kit,
		alt: i18n => i18n.alts.whyUs.sparkles
	},
	{
		imagePath: '/lulav-icons/heart-chest.svg',
		text: i18n => i18n.hiw.whyUs.expenses,
		alt: i18n => i18n.alts.whyUs.heartChest
	}
]

interface SiteMap {
	imagePath: string;
	title: I18nSelector;
	route: string;
	alt: I18nSelector;
}

export const siteMap: SiteMap[] = [
	{
		imagePath: '/lulav-icons/like.svg',
		title: i18n => i18n.homePageText.sitemap.howItWorks,
		route: '/how-it-works',
		alt: i18n => i18n.alts.siteMap.thumbsUp
	},
	{
		imagePath: '/lulav-icons/profile.svg',
		title: i18n => i18n.homePageText.sitemap.enterProfile,
		route: '/profile',
		alt: i18n => i18n.alts.siteMap.enterProfile
	},
	{
		imagePath: '/lulav-icons/heart.svg',
		title: i18n => i18n.homePageText.sitemap.donateTo,
		route: '/associations',
		alt: i18n => i18n.alts.siteMap.giveHeart
	},
	{
		imagePath: '/lulav-icons/locations.svg',
		title: i18n => i18n.homePageText.sitemap.distributionStations,
		route: '/distribution-stations',
		alt: i18n => i18n.alts.siteMap.locations
	},
	{
		imagePath: '/lulav-icons/add-heart.svg',
		title: i18n => i18n.homePageText.sitemap.registerAssociation,
		route: '/associations/registration',
		alt: i18n => i18n.alts.siteMap.addHeart
	},
	{
		imagePath: '/lulav-icons/location.svg',
		title: i18n => i18n.homePageText.sitemap.registerDistStation,
		route: '/distribution-stations/registration',
		alt: i18n => i18n.alts.siteMap.addLocation
	}
]

interface AssociationRegistration {
	imagePath: string;
	text: I18nSelector;
	alt: I18nSelector;
}

export const associationsRegistration: AssociationRegistration[] = [
	{ imagePath: '/lulav-icons/doc.svg', text: i18n => i18n.assoReg.conditions.section46, alt: i18n => i18n.alts.associationReg.document },
	{ imagePath: '/lulav-icons/manager.svg', text: i18n => i18n.assoReg.conditions.properReport, alt: i18n => i18n.alts.associationReg.manager },
	{ imagePath: '/lulav-icons/heart.svg', text: i18n => i18n.assoReg.conditions.social, alt: i18n => i18n.alts.associationReg.heart }
]